import React from "react";
import { flip, offset, shift } from "@floating-ui/dom";
import { Tooltip } from "react-tooltip";

export const PerformanceCagrTooltip = (): React.ReactElement => (
    <Tooltip
        id="ct-tooltip"
        place="bottom"
        positionStrategy="fixed"
        middlewares={[offset(6), flip(), shift({ padding: 8 })]}
        style={{
            fontSize: 11,
            lineHeight: 1.35,
            maxWidth: 260,
            padding: "5px 8px"
        }}
    />
);
